!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("luxon")) : "function" == typeof define && define.amd ? define(["exports", "luxon"], t) : t((e = e || self)["hot-date"] = {}, e.luxon);
}(this, function (e, t) {
  "use strict";

  var n = {
    TIME_WITH_PERIOD: Object.assign(t.DateTime.TIME_SIMPLE, {
      hour12: !1
    })
  };
  e.DateTimeFormat = n, e.areSameDate = function (e, t) {
    return e.hasSame(t, "day") && e.hasSame(t, "month") && e.hasSame(t, "year");
  }, e.differenceInCalendarDays = function (e, n) {
    return e > n ? 0 - Math.floor(t.Interval.fromDateTimes(n, e).toDuration("days").days) : Math.ceil(t.Interval.fromDateTimes(e, n).toDuration("days").days);
  }, e.differenceInCalendarWeeks = function (e, n) {
    return e > n ? 0 - Math.floor(t.Interval.fromDateTimes(n, e).toDuration("weeks").weeks) : Math.ceil(t.Interval.fromDateTimes(e, n).toDuration("weeks").weeks);
  }, e.encodeDate = function (e) {
    return e.toISODate();
  }, e.encodeDateTime = function (e, n) {
    var r = {
      years: e.year,
      month: e.month,
      day: e.day,
      hour: n.hour,
      minute: n.minute,
      seconds: n.second
    };
    return t.DateTime.fromObject(r).startOf("second").toISO({
      suppressMilliseconds: !0,
      includeOffset: !1
    });
  }, e.encodeTime = function (e) {
    return e.startOf("second").toISOTime({
      includeOffset: !1,
      suppressMilliseconds: !0
    });
  }, e.formatDistance = function (e) {
    var n = Math.ceil(e.diffNow("days").days);
    if (-1 === n) return "Yesterday";
    if (0 === n) return "Today";
    if (1 === n) return "Tomorrow";
    if (n >= 14) return e.toLocaleString(t.DateTime.DATE_MED);
    var r = e.toRelativeCalendar();
    return r || (r = e.toLocaleString(t.DateTime.DATE_MED)), r;
  }, e.formatDistanceDays = function (e) {
    var t = Math.ceil(e.diffNow("days").days);
    return -1 === t ? "Yesterday" : 0 === t ? "Today" : 1 === t ? "Tomorrow" : t > -1 ? "in " + t + " days" : -t + " days ago";
  }, e.formatUnitBasedOnValue = function (e, t) {
    return 0 === e ? "" : 1 === e ? e + " " + t.substring(0, t.length - 1) : e + " " + t;
  }, e.getDurationHoursMin = function (e, t) {
    var n = t.diff(e, ["hours", "minutes"]);
    return n.hours && n.minutes ? n.hours + " " + (1 === n.hours ? "hour" : "hours") + " " + Math.trunc(n.minutes) + " min." : n.hours ? n.hours + " " + (1 === n.hours ? "hour" : "hours") : Math.trunc(n.minutes) + " min.";
  }, e.getSemanticTime = function (e, t) {
    var n = e.diffNow().milliseconds,
        r = n < 0,
        o = Math.abs(n),
        a = function a(e) {
      return 1 !== e ? "s" : "";
    };

    if (o < 6e4) return "Just Now";

    if (o < 36e5) {
      var i = Math.round(o / 6e4);
      return r ? i + " minute" + a(i) + " ago" : "In " + i + " minute" + a(i);
    }

    if (o < 432e5) {
      var u = Math.round(o / 36e5);
      return r ? u + " hour" + a(u) + " ago" : "In " + u + " hour" + a(u);
    }

    if (o < 864e5) {
      var s = e.toRelativeCalendar();
      return "" + (null == s ? void 0 : s.charAt(0).toUpperCase()) + (null == s ? void 0 : s.slice(1)) || "";
    }

    if (o < 2592e6) {
      var f = Math.round(o / 864e5);
      return r ? f + " day" + a(f) + " ago" : "In " + f + " day" + a(f);
    }

    return e.toLocaleString({
      weekday: "short",
      day: "numeric",
      month: "short",
      year: t ? "numeric" : void 0
    }).replace(",", "");
  }, e.getShortDate = function (e) {
    return e.toFormat("d MMM y");
  }, e.isDateInFuture = function (e) {
    return e.diffNow("millisecond").milliseconds > 0;
  }, e.isDateInPast = function (e) {
    return e.diffNow("millisecond").milliseconds < 0;
  }, e.timeDurationInHours = function (e, t) {
    return e > t ? t.diff(e, ["hours"]).plus({
      hours: 23
    }) : t.diff(e, ["hours"]);
  }, e.unpackToDate = function (e) {
    return t.DateTime.fromISO(e).set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0
    });
  }, e.unpackToDateTime = function (e) {
    return t.DateTime.fromISO(e);
  }, e.unpackToDateTimeTZ = function (e) {
    return t.DateTime.fromISO(e, {
      setZone: !0
    });
  }, e.unpackToTime = function (e) {
    return t.DateTime.fromISO(e);
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});